import { useQuery } from "convex/react";

import { api } from "@convex/_generated/api";

/**
 * Live subscription for the task-manager surface (`/tasks`). Wraps the
 * server-bucketed `tasks.listForCurrentUser` query — surface separation and
 * state bucketing are decided server-side; this hook only unwraps the
 * snapshot with safe fallbacks. Dedicated (not `useBeads`) so `/tasks`
 * subscribes to the projected view-model, not the full workspace.
 */
export function useTasks() {
  const result = useQuery(api.tasks.listForCurrentUser, {});
  return {
    current: result?.current ?? [],
    held: result?.held ?? [],
    completed: result?.completed ?? [],
    isLoading: result === undefined,
  };
}
